/**
 * Rekenen met kalenderdagen en weken in de lokale tijd (Europe/Amsterdam).
 *
 * Nooit `datum.getTime() + n * 24 * 60 * 60 * 1000`: op de dag van de
 * overgang naar wintertijd duurt een dag 25 uur, naar zomertijd 23 uur.
 * Met vaste milliseconden schuift het raster dan een dag (25-10-2026:
 * zondag werd "Ma 25 okt"). Hier rekent `setDate`/de Date-constructor met
 * kalenderdagen; elke uitkomst is lokale middernacht.
 */

/** Lokale middernacht van dezelfde kalenderdag. */
export function beginVanDag(datum) {
  const d = new Date(datum);
  return new Date(d.getFullYear(), d.getMonth(), d.getDate());
}

/** Lokale middernacht, `n` kalenderdagen later (negatief = eerder). */
export function plusDagen(datum, n) {
  const d = new Date(datum);
  return new Date(d.getFullYear(), d.getMonth(), d.getDate() + n);
}

/** Maandag (lokale middernacht) van de week waarin `datum` valt; zondag hoort bij de week ervoor. */
export function maandagVanWeek(datum) {
  const d = beginVanDag(datum);
  const wd = (d.getDay() + 6) % 7; // ma=0 … zo=6
  return plusDagen(d, -wd);
}

/**
 * Maandag van de week die het ma–vr-raster toont. In het weekend is "deze
 * week" voorbij; dan is het de komende week (een leerling die zaterdag of
 * zondag kijkt, plant vooruit). `offsetWeken` bladert vanaf daar.
 */
export function rasterMaandag(nu, offsetWeken = 0) {
  const vandaag = beginVanDag(nu);
  const wd = (vandaag.getDay() + 6) % 7;
  const weekendSprong = wd >= 5 ? 7 : 0;
  return plusDagen(maandagVanWeek(vandaag), weekendSprong + offsetWeken * 7);
}

/** 'YYYY-MM-DD' van de lokale kalenderdag. */
export function isoDatum(datum) {
  const d = new Date(datum);
  const p = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

/** Aantal kalenderdagen van `van` naar `tot` (los van uren en zomer-/wintertijd). */
export function dagenTussen(van, tot) {
  const a = beginVanDag(van);
  const b = beginVanDag(tot);
  return Math.round((Date.UTC(b.getFullYear(), b.getMonth(), b.getDate())
    - Date.UTC(a.getFullYear(), a.getMonth(), a.getDate())) / 86400000);
}

/** De vijf schooldagen (ma–vr) vanaf maandag `weekStart`, elk op lokale middernacht. */
export function schooldagen(weekStart) {
  return Array.from({ length: 5 }, (_, i) => plusDagen(weekStart, i));
}
